import { DisplayButtons } from '@/components/DisplayButtons';
import {
    EDisplays,
    EJourneys,
    EModals,
    setDisplay,
    setModal,
} from '@/context/display';
import { useAppDispatch } from '@/context/storeHooks';
import { EParameters, getParameters } from '@/utils/setParametersFromParams';

interface IIndicativelyApprovedButtonsProps {
    baseId?: string;
}

export function IndicativelyApprovedButtons({
    baseId,
}: IIndicativelyApprovedButtonsProps): JSX.Element {
    const dispatch = useAppDispatch();
    const params = getParameters();

    // ***** Event Handlers *****
    function handleBackClick(): void {
        const paramJourney = params.get(EParameters.INITIAL_JOURNEY);

        if (paramJourney?.toLocaleUpperCase() === EJourneys.TEST_DRIVE) {
            dispatch(setDisplay(EDisplays.INCOME));
            return;
        }
        dispatch(setDisplay(EDisplays.OCR_SUMMARY));
    }

    function handleNextClick(): void {
        dispatch(setModal(EModals.POSTAPPROVED_PERMISSION_MODAL));
    }

    return (
        <DisplayButtons
            idLeftButton={`${baseId}-button-back`}
            idRightButton={`${baseId}-button-next`}
            rightClick={handleNextClick}
            leftClick={handleBackClick}
        />
    );
}
